// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"DataDictionary_downloadIcon__q6roU"};